export enum RequestWithdrawQueryKeys {
  GET_LIST_REQUEST_WITHDRAW_OWN = 'GET_LIST_REQUEST_WITHDRAW_OWN',
  GET_LIST_REQUEST_WITHDRAW = 'GET_LIST_REQUEST_WITHDRAW',
  GET_DETAIL_REQUEST_WITHDRAW = 'GET_DETAIL_REQUEST_WITHDRAW',
  EXPORT_REQUEST_WITHDRAW = 'EXPORT_REQUEST_WITHDRAW',
}
